import { ChangeDetectionStrategy, ChangeDetectorRef, Component, forwardRef, HostBinding, Input, OnInit, Optional } from '@angular/core';
import { AbstractControl, ControlValueAccessor, FormControl, FormGroupDirective, NG_VALUE_ACCESSOR } from '@angular/forms';
import { SwitcherGroupComponent } from './switcher-group.component';

@Component({
  selector: 'mtg-switcher',
  templateUrl: './switcher.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SwitcherComponent),
      multi: true
    }
  ],
})
export class SwitcherComponent implements OnInit, ControlValueAccessor {
  private control: AbstractControl;
  private onTouch: () => void;
  private onChange: (value) => void;

  @Input()
  value: any;
  @Input()
  formControl: FormControl;
  @Input()
  formControlName: string;
  @Input()
  reverse: boolean;
  checked: boolean;
  @HostBinding('class.switcher-container')
  defaultClass = true;

  get isReverse(): boolean {
    return this.reverse || this.switcherGroupComponent?.reverse;
  }

  constructor(
    @Optional() private parentFormGroup: FormGroupDirective,
    @Optional() private switcherGroupComponent: SwitcherGroupComponent,
    private cdr: ChangeDetectorRef,
  ) {
  }

  ngOnInit(): void {
    if (this.parentFormGroup) {
      this.control = this.formControl || this.parentFormGroup.control.get(this.formControlName);
    } else {
      this.control = this.formControl;
    }
    if (this.switcherGroupComponent) {
      this.checked = (this.switcherGroupComponent.value || []).indexOf(this.value) > -1;
    }
  }

  writeValue(obj: any): void {
    this.checked = obj === this.value;
    this.cdr.markForCheck();
  }

  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  changeValue(checked: boolean) {
    this.checked = checked;
    if (this.onChange) {
      const value = this.value !== undefined ? this.value : true;
      this.onChange(this.checked ? value : null);
    }
    if (this.onTouch) {
      this.onTouch();
    }
    if (this.switcherGroupComponent) {
      this.switcherGroupComponent.onItemChanged(this.value, checked);
    }
  }
}
